"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getEstimatedArrivalTime;
var _axios = _interopRequireDefault(require("axios"));
var _camelCase = _interopRequireDefault(require("../utils/camelCase"));
var _settings = require("../settings");
function getEstimatedArrivalTime(payload) {
  var _getSettings = (0, _settings.getSettings)(),
    getEstimatedArrivalTimeApi = _getSettings.getEstimatedArrivalTimeApi;
  if (typeof getEstimatedArrivalTimeApi === 'string') {
    return (0, _axios["default"])({
      url: getEstimatedArrivalTimeApi,
      crossDomain: true,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      data: JSON.stringify(payload)
    }).then(_camelCase["default"]).then(function (response) {
      // window.console.debug(response);
      if (response.status !== 200) {
        throw new Error("An error occurred while fetching: ".concat(response.statusText));
      }
      return response.data;
    });
  } else if (typeof getEstimatedArrivalTimeApi === 'function') {
    return getEstimatedArrivalTimeApi(payload);
  }
  return Promise.resolve({
    status: 200
  });
}
//# sourceMappingURL=estimatedArrivalTimeApi.js.map